import { Icon } from '@sdb/planning-ui';
import { LoadingIconContent } from './LoadingIcon.styles';
import { LoadingIconType } from './LoadingIcon.types';

const LoadingIcon = ({ size = 'MEDIUM' }: LoadingIconType) => {
  return (
    <LoadingIconContent size={size}>
      <Icon type={'circle-small'} />
      <Icon type={'circle-small'} />
      <Icon type={'circle-small'} />
    </LoadingIconContent>
  );
};

export default LoadingIcon;
